export const ASS_REQUESTS = 'ASS_REQUEST';

export const CLOSE_ASS_REQUEST = `${ASS_REQUESTS}/CLOSE`;
export const SET_ACTIVE_ASS_REQUEST = `${ASS_REQUESTS}/SET_ACTIVE_ASS_REQUEST`;
export const SHOW_ASS_REQUEST_DIALOG = `${ASS_REQUESTS}/SHOW_ASS_REQUEST_DIALOG`;
export const START_ASS_REQUEST = `${ASS_REQUESTS}/START_ASS_REQUEST`;
export const CREATE_V4_ASS_REQUEST = `${ASS_REQUESTS}/CREATE_V4_ASS_REQUEST`;
